import React from 'react';

import clsx from 'clsx';

import MailTo from 'components/MailTo';
import PhoneTo from 'components/PhoneTo';

import styles from './GeneralContactInfo.module.scss';

interface GeneralContactInfoProps {
  name?: string;
  phone?: string;
  email?: string;
}

const GeneralContactInfo = ({
  name = 'HFS Financial Team',
  email = 'info@hfsfin.com',
  phone = '(800) 254-9560',
}: GeneralContactInfoProps) => {
  return (
    <div className={styles.infoContainer}>
      <p className={clsx('body_text--large', styles.contactMessage)}>{name}</p>
      <div>
        <PhoneTo
          number={phone}
          linkClassName={clsx('input_label', styles.phone_link, styles.link)}
          iconClassName={styles.icon}
        />
      </div>
      <div>
        <MailTo email={email} linkClassName={clsx('input_label', styles.link)} iconClassName={styles.icon} />
      </div>
    </div>
  );
};

export default GeneralContactInfo;
